import TodayIcon from "@mui/icons-material/Today";
import {Grid2} from "@mui/material";
import {get, isEqual} from "lodash";
import React from "react";
import Select from "../Select/index";
import {INTERVALS} from "components/common/dateUtils";
import DatePickerRange from "components/common/DatePickerRange";


function transformIntervalValues() {
    return Object.keys(INTERVALS).map((key) => {
        return {
            ...INTERVALS[key],
        };
    });
}

class DateInterval extends React.Component {
    constructor(props) {
        super(props);
        const st = this._getStateByDefaultValue(true);
        this.state = {
            ...st,
        };
    }
    _getStateByDefaultValue = (isInitial) => {
        const dateFrom = get(this.props.defaultValue, "dateFrom", null);
        const dateTo = get(this.props.defaultValue, "dateTo", null);
        const value = get(
            this.props.defaultValue,
            "value",
            isInitial ? INTERVALS.CURRENT_MONTH.value : this.state.value
        );
        return {
            dateFrom,
            dateTo,
            value,
        };
    };
    onChangeStart = (dateFrom) => {
        this.setState(
            {
                dateFrom,
            },
            this.onChange
        );
    };
    onChange = () => {
        const { dateFrom, dateTo, value } = this.state;
        console.log("changing interval", this.state);
        this.props.onChange({ value, dateFrom, dateTo });
    };

    onChangeDateEnd = (dateTo) => {
        this.setState(
            {
                dateTo,
            },
            this.onChange
        );
    };

    onBlurStart = (newDate, currentDate) => {
        if (newDate !== currentDate) {
            this.onChangeStart(newDate);
        }
    };

    onBlurEnd = (newDate, currentDate) => {
        if (newDate !== currentDate) {
            this.onChangeDateEnd(newDate);
        }
    };

    onSelectChange = (value) => {
        this.setState(
            {
                value,
            },
            this.onChange
        );
    };

    formatOptionLabel = (props, state) => {
        const sty =
            state.context !== "menu"
                ? {
                    marginTop: "2px",
                }
                : {};
        return props.value === INTERVALS.CUSTOM_DATE.value ? (
            <div className={"selectIconReportIntervalInput"}>
                {props.label}{" "}
                <TodayIcon />
            </div>
        ) : (
            props.label
        );
    };
    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.defaultValue, prevProps.defaultValue)) {
            const st = this._getStateByDefaultValue();
            this.setState({
                ...st,
            });
        }
    }

    onIntervalChange = (e) => {
        console.log("interva;", e)
        this.setState({
            ...e,
        }, () => {
            console.log(this.state);
            this.onChange();
        });
    }
    render() {
        const { dateFrom, dateTo, value, customGridSize } = this.state;
        const isCustomDate = value && value.value === "CUSTOM_DATE";
        const data = transformIntervalValues();
        let startDate = dateFrom;
        let endDate = dateTo;
        return (
            <Grid2
                container
                spacing={1}
                size={{
                    sm: 12,
                    xs: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }}>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 5,
                        xl: 5
                    }}>
                    <Select
                        placeholder={"Select Interval"}
                        value={value}
                        required
                        defaultMenuPortalTarget
                        formatOptionLabel={this.formatOptionLabel}
                        onChange={this.onSelectChange}
                        options={data}
                    />
                </Grid2>
                {isCustomDate && (
                    <Grid2
                        container
                        size={{
                            xs: 12,
                            lg: 7,
                            xl: 7
                        }}>
                        <DatePickerRange
                            noLabel
                            fieldName="date"
                            start={startDate}
                            end={endDate}
                            onChange={this.onIntervalChange}
                            startSuffix="From"
                            endSuffix="To"
                        />
                    </Grid2>
                )}
            </Grid2>
        );
    }
}

export default DateInterval;
